export default __webpack_public_path__ + "static/media/about-us-img-07.c18aef17.jpg";